import { useNavigate } from 'react-router-dom';
import { Container, Button, Dropdown } from 'react-bootstrap';
import { AppLoader } from '../../../Components/common/AppLoader/AppLoader';
import { HospitalCard } from '../../../Components/ui/HospitalCard/HospitalCard';
import { usePartnerHospitals } from '../../../hooks/usePartnerHospitals';
import './partnerhospitals.css';

export const PartnerHospitals = () => {
  const navigate = useNavigate();
  const {
    countries,
    locationTabs,
    selectedCountry,
    activeLocation,
    setActiveLocation,
    handleCountrySelect,
    filteredHospitals,
    loading,
    error,
  } = usePartnerHospitals();

  return (
    <section className="partner-hospitals">
      <Container fluid>
        <div className="partner-hospitals__header-grid">
          <div className="partner-hospitals__intro">
            <h2 className="partner-hospitals__title">Partner Hospitals</h2>
            <p className="partner-hospitals__subtitle">
              World-class healthcare institutions with advanced facilities and trusted care.
            </p>
          </div>

          <Button
            className="partner-hospitals__view-all"
            onClick={() => navigate('/hospitals')}
          >
            View All &nbsp;→
          </Button>

          <div className="partner-hospitals__filter-row">
            <div className="partner-hospitals__tabs-wrap">
              <div className="partner-hospitals__tabs">
                {locationTabs.map((tab) => (
                  <button
                    key={tab.id}
                    type="button"
                    className={`partner-hospitals__tab ${activeLocation?.id === tab.id ? 'partner-hospitals__tab--active' : ''}`}
                    onClick={() => setActiveLocation(tab)}
                  >
                    {tab.name}
                  </button>
                ))}
              </div>
            </div>

            <Dropdown
              className="partner-hospitals__country-dropdown"
              onSelect={handleCountrySelect}
            >
              <Dropdown.Toggle className="partner-hospitals__country-toggle">
                <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M21 10c0 7-9 13-9 13S3 17 3 10a9 9 0 0 1 18 0z" /><circle cx="12" cy="10" r="3" />
                </svg>
                {selectedCountry?.name || 'Select Country'}
              </Dropdown.Toggle>
              <Dropdown.Menu className="partner-hospitals__country-menu">
                {countries.map((country) => (
                  <Dropdown.Item
                    key={country.id}
                    eventKey={String(country.id)}
                    active={selectedCountry?.id === country.id}
                  >
                    {country.name}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          </div>
        </div>

        {loading && (
          <AppLoader className="py-5" />
        )}

        {!loading && error && (
          <p className="text-center py-4 text-danger">{error}</p>
        )}

        {!loading && !error && (
          <div className="partner-hospitals__scroll-wrap">
            <div className="partner-hospitals__track">
              {filteredHospitals.length > 0 ? (
                filteredHospitals.map((h) => (
                  <div key={h.id} className="partner-hospitals__card-item">
                    <HospitalCard {...h} />
                  </div>
                ))
              ) : (
                <p className="partner-hospitals__empty">No hospitals found for the selected filters.</p>
              )}
            </div>
          </div>
        )}
      </Container>
    </section>
  );
};
